import React from 'react';
import { buildCurrencyFormatter } from 'utils/helpers';

import styles from './AmountValue.module.css';

const getAmoutValue = (value: number | string, currency?: string) => (
  <span className={styles.amount}>
    {buildCurrencyFormatter(currency).format(+value)}
  </span>
);

export default getAmoutValue;
